<form class="container-fluid" novalidate [formGroup]="chequeDetailForm">
  <div class="row">
    <div class="col-6 col-sm-4 col-md-3">
      <div class="form-group">
        <label>{{'ChequeNumber' | translate}}</label>
        <input numbersOnly class="form-control form-control-sm" formControlName="number">
      </div>
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <div class="form-group">
        <label>{{'ChequeAmmount' | translate}}</label>
        <input numbersOnly class="form-control form-control-sm" disabled formControlName="value">
      </div>
    </div>
    <div class="col-12 col-sm-4 col-md-6">
      <div class="form-group">
        <sanabel-selectize appcode="1050" formControlName="cshBankStpCode">
        </sanabel-selectize>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm">
      <div class="form-group">
        <label>{{'IssueDate' | translate}}</label>
        <div class="input-group input-group-sm">
          <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" formControlName="transDate"
            id="transDate" ngbDatepicker #transDate="ngbDatepicker">
          <div for="transDate" class="input-group-addon" (click)="transDate.toggle()">
            <i class="fa fa-calendar"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm">
      <div class="form-group">
        <label>{{'DueDate' | translate}}</label>
        <div class="input-group input-group-sm">
          <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" formControlName="dueDate" id="dueDate"
            required ngbDatepicker #dueDate="ngbDatepicker">
          <div for="dueDate" class="input-group-addon" (click)="dueDate.toggle()">
            <i class="fa fa-calendar"></i>
          </div>
        </div>
      </div>
    </div>

   
  </div>

  <div>
    <btns-ctrl [paramsArr]="controlsParams" [disabled]="chequeDetailForm.invalid" (clicked)="save()"></btns-ctrl>
  </div>
  <div class="row">
    <div class="col-10 mb-3">
      <div class="testClass">
        <!-- <image-upload-new (OutBase64)="onOutBase64($event)" [documentLookupCode]="17"
            [SavedId]="chequeDetailForm.get('serial').value" [height]="112"
             [docFolderLookupSerial]="1" [imgMode]="1">
        </image-upload-new> -->
        <image-upload-new (OutBase64)="onOutBase64($event)" [documentLookupCode]="documentLookupCode"
        [autoUpdate]="true" [height]="50" [imageBase64]="docManagementData.base64"
        [docFolderLookupSerial]="4" (imageObj)="saveimageObj($event)"
        [SavedId]="chequeTransSerial">
    </image-upload-new>

    </div>
    </div>
</div>
</form>